/**
 * adminFetch — wrapper around fetch for all admin API calls.
 * - Always sends session cookie (credentials: "include")
 * - Automatically attaches the Django CSRF token for mutating requests
 * - Prepends the API base URL for context-path-aware deployments
 */

import { apiUrl } from "./config";

function getCsrfToken(): string {
  return (
    document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith("csrftoken="))
      ?.split("=")[1] ?? ""
  );
}

const MUTATING = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export async function adminFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const method = (options.method ?? "GET").toUpperCase();
  const extra: Record<string, string> = {};
  if (MUTATING.has(method)) {
    extra["X-CSRFToken"] = getCsrfToken();
  }
  return fetch(apiUrl(url), {
    ...options,
    credentials: "include",
    headers: { ...(options.headers as Record<string, string> ?? {}), ...extra },
  });
}
